import { createTheme } from '@mui/material/styles';

export const getTheme = (mode: 'light' | 'dark') => createTheme({
    palette: {
        mode,
        primary: {
            main: '#B8860B', // Dark Goldenrod for better contrast (was #D4AF37)
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#1A237E', // Dark Blue
            contrastText: '#FFFFFF',
        },
        background: {
            default: mode === 'light' ? '#F5F5F5' : '#121212',
            paper: mode === 'light' ? '#FFFFFF' : '#1E1E1E',
        },
        text: {
            primary: mode === 'light' ? '#333333' : '#E0E0E0',
            secondary: mode === 'light' ? '#666666' : '#A0A0A0',
        },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontWeight: 700,
        },
        h2: {
            fontWeight: 700,
        },
        h3: {
            fontWeight: 600,
        },
        button: {
            textTransform: 'none',
            fontWeight: 600,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: mode === 'light' ? '#FFFFFF' : '#1E1E1E',
                    color: mode === 'light' ? '#333333' : '#E0E0E0',
                },
            },
        },
    },
});

